import { supabase } from "../supabaseClient";

export async function fetchAccountMapping(orgId) {
  if (!orgId)
    return {
      accounts: [],
      unassignedWebsites: [],
    };

  const queries = [
    supabase
      .from("accounts")
      .select(
        "id, name, products(id, product, event_owner), ga4_properties(id, property_id, property_name), website_urls(id, url)"
      )
      .eq("organization_id", orgId),
    supabase
      .from("website_urls")
      .select("id, url")
      .eq("organization_id", orgId)
      .is("account_id", null),
    supabase
      .from("organizations")
      .select(
        "stripe_subscription_id, price_per_store_cents, price_override_cents, discount_percent, plan:plans(name, max_accounts, monthly_scan_limit)"
      )
      .eq("id", orgId)
      .single(),
  ];

  const [
    { data: accounts, error: accountsError },
    { data: unassignedWebsites = [], error: websitesError },
    { data: organization, error: orgError },
  ] = await Promise.all(queries);

  if (accountsError) {
    console.error("Failed to fetch account mapping", accountsError);
  }

  if (websitesError) {
    console.error("Failed to fetch unassigned websites", websitesError);
  }

  if (orgError) {
    console.error("Failed to fetch organization", orgError);
  }

  return {
    accounts: accounts || [],
    unassignedWebsites,
    organization,
  };
}
